import { loadHbridge } from '@/utils/globalLoader';
import { OPT } from '@/utils/ubtUtils';

let getCityInfoPromise = null;

const DEFAULT_LOCATION = {
  longitude: '121.381716',
  latitude: '31.112818',
  adCode: '310112',
  cityCode: '021',
};

async function getCityInfoByIp() {
  try {
    // 定位逻辑只后hbridge 已完成loadMap，AMap.plugin('AMap.Geolocation',此处方可直接使用AMap.Geolocation
    const geolocation = new window.AMap.Geolocation({
      enableHighAccuracy: false,
      timeout: 5000,
      maximumAge: 1000,
      convert: true,
    });

    if (!getCityInfoPromise) {
      getCityInfoPromise = new Promise((success) => {
        geolocation.getCityInfo((status, result) => {
          if (status === 'complete') {
            success({
              adCode: result.adcode || '',
              cityCode: result.citycode || '',
            });
          } else {
            getCityInfoPromise = null;
            success({
              adCode: '',
              cityCode: '',
            });
          }
        });
      });
    }
    return getCityInfoPromise;
  } catch (e) {
    // empty
  }

  return {
    adCode: '',
    cityCode: '',
  };
}

const user = {
  namespaced: true,
  state: DEFAULT_LOCATION,

  mutations: {
    SET_STATE: (state, nextState) => {
      Object.assign(state, nextState);
    },
  },

  actions: {
    // 用户名登录
    getLocation({ commit }) {
      if (window.__PRERENDER_INJECTED) {
        return Promise.resolve(DEFAULT_LOCATION);
      }
      return loadHbridge()
        .then(({ Native }) => {
          OPT.h5Location('发起精准定位');
          return Native.getCityInfo().catch(() => {
            OPT.h5Location('精准定位失败');
            return getCityInfoByIp()
              .then(({ cityCode, adCode }) => {
                if (cityCode) {
                  OPT.h5Location('ip定位成功');
                } else {
                  throw new Error('ip定位失败');
                }
                return Promise.resolve({
                  longitude: '',
                  latitude: '',
                  adCode,
                  cityCode,
                });
              })
              .catch(() => {
                OPT.h5Location('ip定位失败');
                return Promise.resolve(DEFAULT_LOCATION);
              });
          });
        })
        .then((response) => {
          commit('SET_STATE', response);
          return response;
        })
        .catch((error) => {
          console.error('getLocation 请求失败:', error);
          commit('SET_STATE', DEFAULT_LOCATION);
          return Promise.resolve(DEFAULT_LOCATION);
        });
    },
  },
};

export default user;
